import merge from 'lodash/merge';
import moment from 'moment';

export function extendChartConfig(chartConfig, gettext, color) {
  return merge(chartConfig, {
    chart: {
      x: (d) => moment(d.weekEndDate).format('MMM D'),
      y: (d) => d.timeNotSelling,
      // eslint-disable-next-line
      valueFormat: (val) => parseTimeToHoursAndMinutes(val),
      barColor: () => color,
      yAxis: {
        tickFormat(yAxisValue) {
          // eslint-disable-next-line
          return parseTimeToHoursAndMinutes(yAxisValue);
        },
      },
    },
  });
}

export function parseTimeToHoursAndMinutes(timeInMs) {
  let h = Number.parseInt(moment.duration(timeInMs).asHours());
  let m = moment.duration(timeInMs).minutes();

  if (h < 10) h = `0${h}`;
  if (m < 10) m = `0${m}`;

  return `${h}:${m}`;
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/self-service-out-of-stock/self-service-out-of-stock-widget-service.js